export default __webpack_public_path__ + "static/media/quickstart-step-1.96c19bdb.jpg";